import Link from 'next/link';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { type UserMenuItemProps } from '@customTypes/navigationTypes';

export const UserMenuItem = (props: UserMenuItemProps) => (
  <Link href={props.path} passHref legacyBehavior>
    <MenuItem>
      <ListItemIcon>{props.icon}</ListItemIcon>
      <ListItemText primary={props.name} />
    </MenuItem>
  </Link>
);
